var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminosIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11092",
    "data-name": "Group 11092",
    transform: "translate(-309 -311.552)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(309 311.552)",
    fill: "#9eaced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5954",
    "data-name": "Path 5954",
    d: "M126.627-36.194q-8.5,0-17,0a6.848,6.848,0,0,1-6.3-3.452,6.762,6.762,0,0,1-.909-3.56q0-17.2.007-34.4a6.748,6.748,0,0,1,5.385-6.866,7.271,7.271,0,0,1,1.613-.176q8.5-.019,17-.006a1.885,1.885,0,0,1,1.985,2.488,1.748,1.748,0,0,1-1.486,1.227,6.248,6.248,0,0,1-.812.039q-8.265,0-16.53,0a3.1,3.1,0,0,0-3.324,2.4,3.727,3.727,0,0,0-.074.865q-.005,17.17,0,34.34a3.067,3.067,0,0,0,3.324,3.333c11.408,0,22.816-.019,34.223.023a3.261,3.261,0,0,0,3.408-3.415c-.038-5.451-.012-10.9-.012-16.355,0-.989-.007-1.979,0-2.968a1.869,1.869,0,0,1,1.9-2.092,1.9,1.9,0,0,1,1.854,2.092q0,9.749,0,19.5a6.807,6.807,0,0,1-5.63,6.85,9.291,9.291,0,0,1-1.737.12Q135.066-36.187,126.627-36.194Z",
    transform: "translate(234.882 424.802)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5955",
    "data-name": "Path 5955",
    d: "M240.584-108.715a4.447,4.447,0,0,1-1.443,3.195q-2.97,2.954-5.926,5.923-9.443,9.443-18.875,18.9a3.539,3.539,0,0,1-2.286,1.092c-2.409.237-4.814.521-7.22.78a1.892,1.892,0,0,1-2.066-2.044c.287-2.638.556-5.278.916-7.906a2.761,2.761,0,0,1,.8-1.416q7.212-7.271,14.47-14.5,5.2-5.2,10.409-10.409a4.369,4.369,0,0,1,6.708-.014q1.628,1.622,3.247,3.253A4.234,4.234,0,0,1,240.584-108.715ZM206.763-82.869c.264,0,.438.017.607,0,1.193-.136,2.383-.313,3.579-.4a1.837,1.837,0,0,0,1.251-.6q8.689-8.717,17.4-17.412c.157-.157.306-.323.414-.438l-4.4-4.415a4.638,4.638,0,0,1-.345.432Q216.69-97.122,208.1-88.553a2.64,2.64,0,0,0-.933,1.827C207.1-85.454,206.908-84.19,206.763-82.869Zm26.02-21.61c1.292-1.289,2.6-2.581,3.889-3.893a.61.61,0,0,0-.073-.93q-1.684-1.69-3.376-3.373a.64.64,0,0,0-1.016.031c-.408.415-.822.824-1.234,1.235l-2.554,2.55Z",
    transform: "translate(150.116 451.855)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminosIcon);
export default __webpack_public_path__ + "static/media/terminosIcon.93c0b2852f447899ab054a678c35519f.svg";
export { ForwardRef as ReactComponent };